<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.product')" class="mt-2">
        <b-field
          :label="$t('attributes.product_code')"
          label-position="on-border"
        >
          <b-input v-model="code" disabled expanded></b-input>
        </b-field>

        <b-field :label="$t('attributes.area')" label-position="on-border">
          <b-input v-model="area_name" disabled expanded></b-input>
        </b-field>

        <b-field :label="$t('attributes.catalog')" label-position="on-border">
          <b-input v-model="catalog_names" disabled expanded></b-input>
        </b-field>

        <b-field :label="$t('attributes.days')" label-position="on-border">
          <b-input v-model="days" numeric disabled expanded></b-input>
        </b-field>
      </b-field>

      <form-wrapper :validator="$v.form">
        <form-group horizontal name="name" :label="$t('attributes.name')">
          <b-input
            v-model="form.name"
            name="name"
            :placeholder="$t('message.please_input') + $t('attributes.name')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="english_name"
          :label="$t('attributes.english_name')"
        >
          <b-input
            v-model="form.english_name"
            name="english_name"
            :placeholder="
              $t('message.please_input') + $t('attributes.english_name')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="alias"
          attribute="attributes.product_alias"
          :label="$t('attributes.product_alias')"
        >
          <b-field>
            <b-input
              v-model="form.alias"
              name="alias"
              :placeholder="
                $t('message.please_input') + $t('attributes.product_alias')
              "
              expanded
            >
            </b-input>
            <p class="control">
              <a
                :href="helpImageUrl('團別名稱.png')"
                @click.prevent="onClickImage(helpImageUrl('團別名稱.png'))"
              >
                <img
                  :src="helpImageUrl('團別名稱.png')"
                  alt="團別大標"
                  width="64"
                />
              </a>
            </p>
          </b-field>
        </form-group>

        <b-field horizontal>
          <template #label>
            {{ $t('attributes.operator_remark') }}
            <b-tooltip
              type="is-dark"
              :label="$t('attributes.operator_remark_label')"
            >
              <b-icon size="is-small" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </template>
          <form-group
            name="remark5"
            attribute="attributes.operator_remark"
            expanded
          >
            <b-input
              v-model="form.remark5"
              name="remark5"
              :placeholder="
                $t('message.please_input') +
                  $t('attributes.operator_remark') +
                  $t('attributes.operator_remark_max_length')
              "
              expanded
            ></b-input>
            <p class="control">
              <a
                :href="helpImageUrl('團控表備註.png')"
                @click.prevent="onClickImage(helpImageUrl('團控表備註.png'))"
              >
                <img
                  :src="helpImageUrl('團控表備註.png')"
                  alt="團控表備註"
                  width="64"
                />
              </a>
            </p>
          </form-group>
        </b-field>

        <b-field horizontal :label="$t('attributes.status')" class="mt-4">
          <form-group
            name="shelve_on"
            attribute="attributes.shelve_status"
            class="mt-1"
          >
            <b-switch v-model="form.shelve_on" name="shelve_on">
              {{ $t('attributes.shelve_status') }}
            </b-switch>
          </form-group>

          <form-group
            name="situation"
            :label="$t('attributes.situation')"
            label-position="on-border"
          >
            <b-select v-model="form.situation" name="situation">
              <option
                v-for="option in situationTypes"
                :key="option.id"
                :value="option.id"
              >
                <!-- eslint-disable-next-line -->
              <p v-html="option.name"></p>
              </option>
            </b-select>
          </form-group>

          <form-group
            name="sort"
            :label="$t('attributes.sort')"
            label-position="on-border"
          >
            <b-select v-model="form.sort" name="sort">
              <option
                v-for="option in sort_range"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </b-select>
          </form-group>

          <form-group
            name="airline"
            :label="$t('attributes.airline')"
            label-position="on-border"
          >
            <b-autocomplete
              ref="airlineInput"
              v-model="selectedAirline"
              name="airline"
              field="display_name"
              :data="airlines"
              :placeholder="
                $t('message.please_input') + $t('attributes.airline')
              "
              :open-on-focus="true"
              @typing="onSelectingAirline"
              @select="onSelectedAirline"
            >
              <template #default="props">
                <div class="media">
                  <div class="media-left" style="width: 20px">
                    {{ props.option.code }}
                  </div>
                  <div class="media-content">
                    {{ props.option.name }}({{ props.option.english_name }})
                  </div>
                </div>
              </template>
              <template #empty>
                No results found
              </template>
            </b-autocomplete>
          </form-group>
        </b-field>

        <form-group
          horizontal
          name="attribute"
          :label="$t('attributes.attribute')"
        >
          <b-taginput
            v-model="selectedAttributes"
            :data="filteredTags"
            autocomplete
            field="name"
            icon="label"
            :open-on-focus="focus"
            :placeholder="
              $t('message.please_input') +
                $t('attributes.attribute') +
                $t('attributes.name')
            "
            :before-adding="beforeAdding"
            @typing="getFilteredTags"
          >
            <template v-slot="props">
              {{ props.option.name }}
            </template>
            <template #empty>
              There are no items
            </template>
          </b-taginput>
        </form-group>

        <form-group
          horizontal
          name="doc_url"
          attribute="attributes.pdf_url"
          :label="$t('attributes.pdf_url')"
        >
          <b-input
            v-model="form.doc_url"
            name="doc_url"
            :placeholder="$t('message.please_input') + $t('attributes.pdf_url')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="external_url"
          :label="$t('attributes.external_url')"
        >
          <b-input
            v-model="form.external_url"
            name="external_url"
            :placeholder="
              $t('message.please_input') + $t('attributes.external_url')
            "
            expanded
          ></b-input>
        </form-group>

        <b-field horizontal grouped>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            style="width: 100%"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-danger"
            icon-left="delete"
            style="width: 100%"
            @click.prevent="onDelete"
          >
            {{ $t('attributes.delete') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>

    <b-modal
      :active.sync="showMessageModel"
      :can-cancel="false"
      scroll="keep"
      has-modal-card
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ $t('attributes.shelve_off') + $t('attributes.product') }}
          </p>
        </header>
        <section class="modal-card-body">
          <p>
            <span style="color: red;">是否把目前上架的出發日期下架？</span>
          </p>
          <p v-html="departureDates"></p>
        </section>
        <footer class="modal-card-foot">
          <b-button
            disabled="disabled"
            type="is-info"
            style="width: 100%;"
            @click="onUpdate(true)"
          >
            {{ $t('attributes.yes') }}
          </b-button>
          <b-button
            type="is-link is-light"
            style="width: 100%;"
            @click="onUpdate(false)"
          >
            {{ $t('attributes.no') }}
          </b-button>
        </footer>
      </div>
    </b-modal>

    <b-loading :active.sync="sending" is-full-page></b-loading>
  </section>
</template>

<script>
import { debounce } from 'lodash'
import { required, maxLength } from 'vuelidate/lib/validators'
import { AIRLINE_API, ATTRIBUTES_API, PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'ProductBasicForm',

  props: {
    product: {
      required: true,
      type: Object
    },
    situationTypes: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      sending: false,

      code: this.product.code,
      area_name: this.product.area_name,
      catalog_names: this.product.catalog_name_list.join(','),
      days: this.product.days,

      form: this.extractFormValues(this.product),

      airlines: [],
      selectedAirline: null,
      sort_range: [...Array(50).keys()].map(i => i + 1),

      filteredTags: [],
      attributes: [],
      selectedAttributes: this.extractSelectedAttributeValues(
        this.product.product_attributes
      ),
      focus: true,
      departureDates: '',

      isImageModalActive: false,
      selectedImageUrl: null,

      showMessageModel: false
    }
  },
  validations: {
    form: {
      name: { required },
      english_name: { maxLength: maxLength(50) },
      alias: { maxLength: maxLength(100) },
      remark5: {},
      airline: {},
      shelve_on: {},
      situation: {},
      sort: {},
      product_attributes: {},
      doc_url: { maxLength: maxLength(500) },
      external_url: { maxLength: maxLength(500) },
      orientation_url: { maxLength: maxLength(500) },
      menu_url: { maxLength: maxLength(500) },
      travel_groups_down: {}
    }
  },
  watch: {
    product(newProduct) {
      this.code = newProduct.code
      this.area_name = newProduct.area_name
      this.days = newProduct.days

      this.form = this.extractFormValues(newProduct)
      this.selectedAttributes = this.extractSelectedAttributeValues(
        newProduct.product_attributes
      )

      this.selectedAirline = null
      this.getAirlines(this.form.airline)
      this.loadDepartureDates()
    }
  },
  mounted() {
    this.getAirlines(this.form.airline)
    this.getAttributes()
    this.loadDepartureDates()
  },
  methods: {
    async loadDepartureDates() {
      try {
        const api = `${PRODUCTS_API}/${this.code}/dates`

        const res = await this.axios.get(api)
        this.departureDates = res.data.message
      } catch (e) {
        this.departureDates = ''
        notifyService.error(e)
      }
    },
    extractFormValues(data) {
      return {
        name: data.name,
        english_name: data.english_name,
        alias: data.alias,
        remark5: data.remark5,
        shelve_on: data.shelve_on,
        airline: data.airline,
        situation: data.situation,
        sort: data.sort,
        attributes: [],
        doc_url: data.doc_url,
        external_url: data.external_url,
        orientation_url: data.orientation_url,
        menu_url: data.menu_url,
        travel_groups_down: !data.shelve_on
      }
    },
    extractSelectedAttributeValues(data) {
      let array = []
      if (!data) {
        return []
      }
      data.forEach(item => {
        array.push(item.attributes)
      })
      return array
    },
    onSelectingAirline: debounce(function(search) {
      this.getAirlines(search)
    }, 500),
    onSelectedAirline(option) {
      this.form.airline = option && option.code.trim()
    },
    async getAirlines(search) {
      const api = `${AIRLINE_API}/list`
      const params = {
        search: search
      }

      try {
        const res = await this.axios.get(api, { params })
        this.airlines = res.data.data.map(air => ({
          ...air,
          code: air.code.trim(),
          name: air.name.trim(),
          english_name: air.english_name ? air.english_name.trim() : '',
          display_name: this.formatAirlineName(air)
        }))

        if (!this.selectedAirline) {
          const air = this.airlines.find(a => a.code === search)
          this.selectedAirline = air && air.display_name
        }
      } catch (e) {
        this.airlines = []

        notifyService.fetch_error('airline', e)
      }
    },
    async getAttributes() {
      const api = `${ATTRIBUTES_API}/list`
      try {
        const res = await this.axios.get(api)
        this.attributes = res.data.data
        this.filteredTags = this.attributes
      } catch (e) {
        this.attributes = []
        this.filteredTags = []
        notifyService.fetch_error('attribute', e)
      }
    },
    getFilteredTags(text) {
      this.filteredTags = this.attributes.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        )
      })
    },
    beforeAdding(tag) {
      let obj = []
      obj = this.selectedAttributes.find(function(item) {
        return item.id === tag.id
      })
      if (obj === undefined) {
        return tag
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      if (!this.form.shelve_on && this.departureDates) {
        this.showMessageModel = true
      } else {
        await this.onUpdate(false)
        this.showMessageModel = false
      }
    },
    async onUpdate(travel_groups_down) {
      this.sending = true
      try {
        this.form.travel_groups_down = travel_groups_down
        this.form.attributes = this.selectedAttributes
        const api = `${PRODUCTS_API}/${this.code}/basic`
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
        this.showMessageModel = false
      }
    },
    onDelete() {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          this.deleteProduct()
        }
      })
    },
    async deleteProduct() {
      const api = `${PRODUCTS_API}/${this.code}`

      this.sending = true
      try {
        await this.axios.delete(api)

        this.$emit('deleted', this.code)
        notifyService.success(this.$t('attributes.delete_succeed'))
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  select {
    width: 150px;
  }
}
</style>
